import { ElementBuilder } from "@universityofmaryland/web-builder-library";
import * as token from "@universityofmaryland/web-token-library";
import * as layout from "@universityofmaryland/web-styles-library/layout";
const CreateQuoteActionElement = ({
  action,
  image,
  includesAnimation,
  isTypeFeatured = false
}) => new ElementBuilder(action).withClassName("quote-container-actions").withStyles({
  element: {
    marginTop: token.spacing.sm,
    display: "block",
    ...!isTypeFeatured && {
      ...layout.grid.inline.tabletRows
    },
    ...includesAnimation && (!isTypeFeatured || isTypeFeatured && !image) && {
      opacity: "0",
      transform: "translateY(20px)",
      transition: "opacity 1s ease, transform 0.5s ease"
    }
  }
}).build();
const createCompositeQuoteAction = CreateQuoteActionElement;
export {
  createCompositeQuoteAction
};
//# sourceMappingURL=action.js.map
